import type { VisitEventDto } from "@school-sales-ai/shared";

const ACTOR_LABEL: Record<VisitEventDto["actor"], string> = {
  agent: "agente",
  crm_user: "equipo",
  system: "sistema",
};

function shortDateTime(iso: string): string {
  return new Intl.DateTimeFormat("es-MX", {
    day: "numeric",
    month: "short",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(new Date(iso));
}

function eventLabel(event: VisitEventDto): string {
  switch (event.type) {
    case "booked":
      return `Agendada por el ${ACTOR_LABEL[event.actor]}`;
    case "rescheduled": {
      const from = event.payload?.from ? shortDateTime(event.payload.from) : null;
      const to = event.payload?.to ? shortDateTime(event.payload.to) : null;
      const move = from && to ? ` · ${from} → ${to}` : "";
      return `Reprogramada por el ${ACTOR_LABEL[event.actor]}${move}`;
    }
    case "cancelled": {
      const reason = event.payload?.reason ? ` · ${event.payload.reason}` : "";
      return `Cancelada por el ${ACTOR_LABEL[event.actor]}${reason}`;
    }
    case "reminder_sent":
      return "Recordatorio enviado";
    case "marked_attended":
      return "Asistencia registrada: asistió";
    case "marked_no_show":
      return "Asistencia registrada: no asistió";
  }
}

type Props = {
  events: VisitEventDto[];
  /** Cap the list (LeadDetail shows the latest 5). */
  limit?: number;
};

export function VisitEventsList({ events, limit }: Props): React.JSX.Element | null {
  const visible = limit ? events.slice(0, limit) : events;
  if (visible.length === 0) return null;
  return (
    <ul className="flex flex-col gap-1.5">
      {visible.map((event) => (
        <li key={event.id} className="flex items-baseline justify-between gap-2 text-[12px]">
          <span className="min-w-0 text-ink-600">{eventLabel(event)}</span>
          <span className="shrink-0 text-ink-300">{shortDateTime(event.createdAt)}</span>
        </li>
      ))}
    </ul>
  );
}
